import React from 'react';
import { useTranslation } from 'react-i18next';
import theme from '../../../styles/theme';
import useInView from '../../../hooks/useInView';

const stats = [
  { key: 'stores', value: '10+' },
  { key: 'orders', value: '5,000+' },
  { key: 'modules', value: '5' },
  { key: 'uptime', value: '99.9%' },
];

const SocialProofSection = () => {
  const { t } = useTranslation();
  const [ref, visible] = useInView();

  const s = {
    section: {
      backgroundColor: theme.colors.background.paper,
      borderBottom: `1px solid ${theme.colors.border.light}`,
      padding: `${theme.spacing['2xl']} ${theme.spacing.xl}`,
    },
    inner: {
      maxWidth: '1120px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: theme.spacing.xl,
      textAlign: 'center',
    },
    statValue: {
      fontSize: theme.typography.fontSize['4xl'],
      fontWeight: theme.typography.fontWeight.bold,
      color: theme.colors.primary.main,
      fontFamily: theme.typography.fontFamily.heading,
      display: 'block',
      marginBottom: theme.spacing.xs,
      opacity: 0,
      transform: 'translateY(16px)',
      transition: 'opacity 0.5s ease, transform 0.5s ease',
    },
    statValueVisible: {
      opacity: 1,
      transform: 'translateY(0)',
    },
    statLabel: {
      fontSize: theme.typography.fontSize.sm,
      color: theme.colors.text.secondary,
      fontWeight: theme.typography.fontWeight.medium,
    },
  };

  return (
    <section style={s.section}>
      <div style={s.inner} ref={ref} className="social-proof-grid">
        {stats.map(({ key, value }, i) => (
          <div key={key}>
            <span
              style={{
                ...s.statValue,
                ...(visible ? s.statValueVisible : {}),
                transitionDelay: `${i * 100}ms`,
              }}
            >
              {value}
            </span>
            <span style={s.statLabel}>{t(`public.stats.${key}`, key)}</span>
          </div>
        ))}
      </div>
      <style>{`
        @media (max-width: 600px) {
          .social-proof-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>
    </section>
  );
};

export default SocialProofSection;
